import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';


class HistoryPaginator extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      history,
      selectedPageNum,
      changePage,
      case_uuid,
    } = this.props;

    const numPages = Math.ceil(history.total_pages || 0);
    const allItems = Math.ceil(history.total_items || 0);
    const pageRange = _.range(numPages);
    const nextPage = selectedPageNum + 1;
    const prevPage = selectedPageNum - 1;
    const lastPage = pageRange[pageRange.length - 1] + 1;

    const max = 6;

    const pageIconCount = (numPages <= max)
      ? numPages
      : max;

    let paginatorItems = _.range(pageIconCount);

    if (selectedPageNum < max) {
      // take 1-9 + numPages
      paginatorItems = paginatorItems.map((el, idx) => {
        if (idx === paginatorItems.length - 1) {
          return numPages;
        }
        return idx + 1;
      });
    } else if (selectedPageNum >= numPages - (max + 2)) {
      // 1 + take currPage - max   (ex: 14)
      // 1 + take curr Page - max  (ex 10) with 12
      paginatorItems = paginatorItems.map((el, idx) => {
        if (idx === paginatorItems.length - 1) {
          return 1;
        }
        return numPages - idx;
      }).reverse();
    } else {
      // ex case 13
      // 1.. (1-4 range) currPage (1-4 range)..max
      // 1,...  9, 10, 11, 12, 13, 14, 15, 16, 17, ..22
      paginatorItems = paginatorItems.map((el, idx) => {
        if (idx === 0) {
          return 1;
        }
        if (idx === paginatorItems.length - 1) {
          return numPages;
        }
        return (selectedPageNum + idx) - 5;
      });
    }

    paginatorItems = paginatorItems.reduce((accum, el, idx) => {
      const key = `paginator-item${idx}`;
      const item = { page: el, active: (selectedPageNum === el) };
      const clsName = (item.active)
        ? 'active item'
        : 'item';

      if (idx !== 0 && paginatorItems[idx - 1] !== paginatorItems[idx] - 1) {
        return accum.concat([
          <span className="item ellipse" key={`${key}-ellipse`}>...</span>,
          <span
            key={key}
            className={clsName}
            onClick={changePage.bind(null, { page: el, page_index: el })}>
            { el }
          </span>,
        ]);
      }
      return accum.concat([
        <span
          key={key}
          className={clsName}
          onClick={changePage.bind(null, { page: el, page_index: el })}>
          { el }
        </span>,
      ]);
    }, []);

    const paginator = paginatorItems;

    const pageBackward = (selectedPageNum !== 1)
      ? changePage.bind(null, { page: selectedPageNum - 1, page_index: prevPage })
      : () => null;

    const pageForward = (selectedPageNum !== lastPage)
      ? changePage.bind(null, { page: selectedPageNum, page_index: nextPage })
      : () => null;

    return (
      <div className="history-pagination">
        <div className="ui small borderless menu" id="history-toolbar">
          <div className={`item ${(selectedPageNum === 1) ? 'disabled' : ''}`}
               title="Go to previous page"
               onClick={pageBackward}>
            ←
          </div>

          { paginator }
          { numPages > 1 &&
          <div className="view-all item"
               onClick={changePage.bind(null, { page_index: 0, page_size: allItems })}>
            View all
          </div>
          }

          <div className={`item ${(selectedPageNum === lastPage) ? 'disabled' : ''}`}
               title="Go to next page"
               onClick={pageForward}>
            →
          </div>
          { this.props.showUpdateHistory &&
            <div
              id="update-from-pacer-link"
              onClick={() => this.props.togglePacerFilterSection()}
              >
              <img src="/sites/all/themes/inforuptcy/icons/icon-update.png" height="23" width="23" />
              <span className={`selected-history-filter-${this.props.showPacerFilterSection}`}>Update History</span>
            </div>
          }
        </div>
      </div>
    );
  }
}

HistoryPaginator.defaultProps = {
};

HistoryPaginator.propTypes = {
  history: PropTypes.object.isRequired,
  case_uuid: PropTypes.string.isRequired,
  selectedPageNum: PropTypes.number.isRequired,
  changePage: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default HistoryPaginator;



// WEBPACK FOOTER //
// ./src/components/case/history/HistoryPaginator.jsx